<template>

</template>


<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator';

import axios from 'axios';
import VueAxios from 'vue-axios';
import { AxiosResponse } from 'axios';
import { ICarnegoUser } from '../main';

interface ISensorData {
    headers: string[];
    values: any[][];
}

@Component({
    components: {
    },
})
export default class Data extends Vue {

    public async created() {
        const self = this;
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>